import React, { useEffect, useState } from 'react';
import HOME_TOPIC_TWO from '../../utils/assets/png/HomeTopic-Two.png';

// Cards overlay the image only when there's room (~800px image)
const useIsMobile = (breakpoint = 900) => {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);
  return isMobile;
};

const HomeTopicTwo = () => {
  const isMobile = useIsMobile();

  const cardBase = {
    borderRadius: '20px',
    padding: '20px',
    boxSizing: 'border-box',
  };

  const darkCard = {
    ...cardBase,
    backgroundColor: '#181436',
    border: '1px solid #181436',
    ...(isMobile
      ? { width: '100%' }
      : { position: 'absolute', top: 50, left: 0, width: '280px', minHeight: '210px' }),
  };

  const yellowCard = {
    ...cardBase,
    backgroundColor: 'rgb(252, 231, 107)',
    ...(isMobile
      ? { width: '100%', marginTop: '16px' }
      : { position: 'absolute', top: 140, left: 520, width: '260px', minHeight: '200px' }),
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#f6f6f6',
        width: '100%',
        boxSizing: 'border-box',
        padding: isMobile ? '0 20px 40px' : '0 0 40px',
      }}
    >
      <div
        style={{
          width: isMobile ? '100%' : '60%',
          marginTop: isMobile ? '40px' : '50px',
          fontSize: isMobile ? '26px' : '35px',
          fontWeight: 600,
          fontFamily: 'Inter Medium',
          lineHeight: isMobile ? '32px' : '40px',
          textAlign: 'center',
          color: '#1B1642',
        }}
      >
        Create a new source of ongoing passive income by inviting customers to our platform
      </div>
      <div
        style={{
          width: isMobile ? '100%' : '40%',
          textAlign: 'center',
          color: '#1B1642',
          fontFamily: 'Inter Regular',
          fontSize: isMobile ? '18px' : '22px',
          lineHeight: isMobile ? '26px' : '30px',
          letterSpacing: '0.4px',
          marginTop: '15px',
        }}
      >
        More customers you invite, more revenue you earn — no limits.
      </div>

      <div
        style={{
          position: 'relative',
          marginTop: '20px',
          width: '100%',
          maxWidth: '800px',
        }}
      >
        <img
          alt=''
          src={HOME_TOPIC_TWO}
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />

        <div style={isMobile ? { marginTop: '20px' } : undefined}>
          <div style={darkCard}>
            <div style={{ fontFamily: 'Inter Bold', fontSize: '20px', color: 'white' }}>
              Free social media advertising
            </div>
            <div
              style={{
                fontFamily: 'Inter Regular',
                fontSize: '16px',
                lineHeight: '22px',
                marginTop: '5px',
                color: 'white',
              }}
            >
              Partner with us and get free social media advertising. We cover the ad cost, and you
              offer a first-time discount—growing your restaurant and ours together
            </div>
          </div>

          <div style={yellowCard}>
            <div style={{ fontFamily: 'Inter Bold', fontSize: '20px', color: 'rgb(27, 22, 66)' }}>
              1.7 million+
            </div>
            <div
              style={{
                fontFamily: 'Inter Regular',
                fontSize: '16px',
                lineHeight: '22px',
                marginTop: '5px',
                color: 'rgb(27, 22, 66)',
              }}
            >
              Over 1.7 million active users are on social media within a 10-mile radius — a huge
              opportunity to get your restaurant in front of the right audience.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTopicTwo;
